<template>
<div>

	<div class="d-flex justify-content-between align-items-center">
		<h2>
			Change Order Quotes<br>
			<small>
				Project #{{$store.project.job_num}}, {{$store.project.job_name}}
			</small>
		</h2>

		<div>
			<router-link :to="'/project/'+$route.params.id+'/change-quotes/new'" class="btn btn-success">
				<i class="fa fa-plus"></i>
				New Quote
			</router-link>
		</div>
	</div>

	<div class="d-flex flex-wrap">
		<info-box label="Total All Changes" :value="totals.all" :stacked="true"></info-box>
		<info-box label="Total Accepted" :value="totals.accepted" :stacked="true"></info-box>
		<info-box label="Total Rejected" :value="totals.rejected" :stacked="true"></info-box>
		<info-box label="Total Pending" :value="totals.pending" :stacked="true"></info-box>
	</div>

	<table-list record-name="Quote"
		:fields="fields"
		:records="mutatedQuotes"
		:hide-record-count="true"
		:has-edit="'/project/'+$route.params.id+'/change-quotes/{?}'"
		:clickable-row="true"
		id-field="slug"
		v-on:modelChange="fetchQuotes">
	</table-list>
</div>
</template>
<script type="text/javascript">
import TableList from "@/components/TableList"
import InfoBox from "@/components/InfoBox"

export default {
	components: {
		TableList,
		InfoBox
	},
	data() {
		return {
			quotes: [],
			fields: [
				{label: "Quote #",key:'quoteNum'},
				{label: "Status", key: "combinedStatus"},
				{label: "Request #",key:'request_num'},
				{label: "Change Ref #",key:"change_order_ref"},
				{label: "Pretax Total", key: "pretax_total",align:"right"},
				{label: "Grand Total", key: "grand_total",align:"right"},
				{label: "Issue Date", key: "issueDate"},
				{label: "Seen by Customer",key: 'seenByCustomer',type:"boolean",align:'center'}
			]
		}
	},
	watch: {
		'$store.project'() {
			if ("id" in this.$store.project)
				this.fetchQuotes()
		}
	},
	computed: {
		totals() {
			let totals = {
				all: this.calcTotal(false,this.quotes),
				accepted: this.calcTotal("Accepted",this.quotes),
				rejected: this.calcTotal("Rejected",this.quotes),
				pending: this.calcTotal("Pending Approval",this.quotes)
			}

			return totals
		},
		mutatedQuotes() {
			let vm = this
			return this.quotes.map(quote => {
				quote.seenByCustomer = false

				let prefix = "Q"
				if (quote.quote_status == 'Accepted')
					prefix = "C"

				quote.quoteNum = prefix+vm.$store.project.job_num+"-"+quote.quote_num

				quote.issueDate = ""
				if (quote.issue_date)
					quote.issueDate = vm.formatDate(quote.issue_date)

				if (!quote.quote_status && quote.last_issued)
					quote.combinedStatus = "Issued"
				else if (!quote.quote_status && quote.is_finalized == 1)
					quote.combinedStatus = "Finalized (Unsent)"
				else if (quote.quote_status)
					quote.combinedStatus = quote.quote_status
				else
					quote.combinedStatus = "Draft"

				quote.seenByCustomer = false
				try {
					let log = JSON.parse(quote.seen_log_json)

					if (log.length > 0) 
						quote.seenByCustomer = true
				}
				catch (Ex) {}
				
				return quote
			})
		}
	},
	methods: {
		calcTotal(status,changes) {
			return changes.filter(change => (change.quote_status == status || !status) && change.is_finalized == 1).reduce((acc,item) => acc + +item.grand_total,0).toCurrency()
		},
		fetchQuotes() {
			let vm = this

			let params = {
				filters: [
					["job_id",this.$store.project.id]
				]
			}

			this.getJSON("JobChangeQuote/get",params).then(response => {
				if (response.success)
					vm.quotes = response.data
			})
		}
	},
	created() {
		if ("id" in this.$store.project)
			this.fetchQuotes()
	}
}
</script>